module.exports = __webpack_public_path__ + "img/SAVE_CLOSE.ae402bca.svg";